import { Building2 } from "lucide-react";

export const BedrijfsafsprakenMelding = () => (
  <div
    data-testid="bedrijfsafspraken-melding"
    className="flex gap-2.5 items-start rounded-md border border-slate-200 bg-slate-50 p-3 text-sm text-slate-600"
  >
    <Building2 className="w-4 h-4 mt-0.5 shrink-0 text-slate-400" />
    <span>
      Let op: binnen uw organisatie kunnen aanvullende bedrijfsafspraken, ondernemingsregelingen
      of overgangsregelingen van toepassing zijn. Controleer bij twijfel de interne regelingen van
      uw werkgever.
    </span>
  </div>
);

export default BedrijfsafsprakenMelding;
